module.exports = __webpack_public_path__ + "static/media/9DESA27.1f3c413b.jpg";